/** @format */

import {createContext, useContext, useMemo, useState, ReactNode} from 'react';

interface NoteOpenContextValue {
  openKey: string | null;
  setOpenKey: (key: string | null) => void;
}

const NoteOpenContext = createContext<NoteOpenContextValue | null>(null);

interface Props {
  children: ReactNode;
}

export const NoteOpenProvider = ({children}: Props) => {
  const [openKey, setOpenKey] = useState<string | null>(null);

  // Memoize to prevent consumer re-renders when NoteOpenProvider re-renders without state change.
  const value = useMemo(() => ({openKey, setOpenKey}), [openKey]);

  return <NoteOpenContext.Provider value={value}>{children}</NoteOpenContext.Provider>;
};

export const useNoteOpen = (): NoteOpenContextValue => {
  const context = useContext(NoteOpenContext);
  if (!context) {
    throw new Error('useNoteOpen must be used within NoteOpenProvider');
  }
  return context;
};
